<script setup lang="ts">
import EventSettingsSwitch from './EventSettingsSwitch.vue'
</script>

<template>
  <EventSettingsSwitch settingName="invertedParticipants">
    <span class="w-20">Inverted Participants</span>
  </EventSettingsSwitch>
</template>
